/**
 * Adobe Tracking Context
 */

import { createContext, useContext, Context } from 'react';

import AdobeTrackingPlugin from './AdobeTrackingPlugin';

export type AdobeTrackingReactContext = Context<AdobeTrackingPlugin>;

const AdobeTrackingContext = createContext<AdobeTrackingPlugin>(undefined as unknown as AdobeTrackingPlugin) as AdobeTrackingReactContext;

const useAdobeTrackingContext = () => useContext(AdobeTrackingContext);

export { AdobeTrackingContext, useAdobeTrackingContext };
